/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faAngleUp, faCreditCard } from '@fortawesome/free-solid-svg-icons';
import { get, sumBy } from 'lodash-es';
import {
  Button,
  Col,
  Container,
  Row,
  Table,
  UncontrolledCollapse
} from 'reactstrap';
import {
  preformatFloat,
  formatCurrencyForLocale,
  getInvoiceDetailStatus
} from '../../../utilities/invoiceUtils';

const AdditionalChargesTable = ({
  currencySymbol,
  invoice
}) => {
  const [arrowUp, setArrowUp] = useState(true);
  const blockEl = 'invoices__edit-invoices';

  let additionalChargeTotal = 0;
  invoice.invoiceDetails.forEach(item => {
    if (item.additionalPriceInfo !== null) {
      const thisItem = parseFloat(preformatFloat(item.additionalPriceInfo.tax)) + parseFloat(preformatFloat(item.additionalPriceInfo.other)) + parseFloat(preformatFloat(item.additionalPriceInfo.shipping)) + parseFloat(preformatFloat(item.additionalPriceInfo.insurance));
      additionalChargeTotal += thisItem;
    }
  });

  const isTableOpen = additionalChargeTotal > 0;

  const arrowToggler = () => {
    setArrowUp((prev) => !prev);
  };

  const additionTotalPerItem = (lotID) => {
    const currentLot = invoice.invoiceDetails.find((lot) => lot.lotID === lotID);
    let itemTotal = 0;

    if (currentLot.additionalPriceInfo) {
      itemTotal = parseFloat(preformatFloat(currentLot.additionalPriceInfo.tax))
      + parseFloat(preformatFloat(currentLot.additionalPriceInfo.other))
      + parseFloat(preformatFloat(currentLot.additionalPriceInfo.shipping))
      + parseFloat(preformatFloat(currentLot.additionalPriceInfo.insurance));
    }
    return itemTotal;
  };

  if (additionalChargeTotal === 0) {
    return null;
  }

  return (
    <>
      <div
        className="w-100 align-right mt-2 font-weight-bold cursor-pointer"
        id={`addCharges_${invoice.invoiceID}`}
        onClick={() => arrowToggler()}
      >
        <span>Total Additional Charges</span>
        <span className="ml-5 mr-3">{currencySymbol}{formatCurrencyForLocale(additionalChargeTotal)}</span>
        {arrowUp
          ? (
            <FontAwesomeIcon
              icon={faAngleUp}
              id={`addChargeToggleUp_${invoice.invoiceID}`}
            />
          )
          : (
            <FontAwesomeIcon
              icon={faAngleDown}
              id={`addChargeToggleDown_${invoice.invoiceID}`}
            />
          )}
      </div>

      <UncontrolledCollapse
        toggler={`addCharges_${invoice.invoiceID}`}
        className="w-100"
        defaultOpen={isTableOpen}
      >

        <Table bordered className={`${blockEl}__invoice__amounts mt-2`}>
          <thead>
            <tr className="font-weight-bold">
              <td className="width-100">Session</td>
              <td className="width-60">Lot</td>
              <td>Additional Tax</td>
              <td>Additional S/H</td>
              <td>Additional Insurance</td>
              <td>Additional Other</td>
              <td>Total</td>
              <td className="width-200">Status</td>
            </tr>
          </thead>
          <tbody>
            {invoice.invoiceDetails
                      && invoice.invoiceDetails.length
              ? invoice.invoiceDetails.map((detail) => (
                <tr className={`${blockEl}__invoice__item`} key={`item_${detail.invoiceDetailID}`}>
                  <td>{detail.saleIdentifier}</td>
                  <td>{detail.lotNum}{detail.lotNumExt}</td>
                  <td>
                    <Row>
                      <Col>{currencySymbol}</Col>
                      <Col className="text-right">{formatCurrencyForLocale(get(detail, 'additionalPriceInfo.tax', 0))}</Col>
                    </Row>
                  </td>
                  <td>
                    <Row>
                      <Col>{currencySymbol}</Col>
                      <Col className="text-right">{formatCurrencyForLocale(get(detail, 'additionalPriceInfo.shipping', 0))}</Col>
                    </Row>
                  </td>
                  <td>
                    <Row>
                      <Col>{currencySymbol}</Col>
                      <Col className="text-right">{formatCurrencyForLocale(get(detail, 'additionalPriceInfo.insurance', 0))}</Col>
                    </Row>
                  </td>
                  <td>
                    <Row>
                      <Col>{currencySymbol}</Col>
                      <Col className="text-right">{formatCurrencyForLocale(get(detail, 'additionalPriceInfo.other', 0))}</Col>
                    </Row>
                  </td>
                  <td>
                    <Row>
                      <Col>{currencySymbol}</Col>
                      <Col className="text-right">{formatCurrencyForLocale(additionTotalPerItem(detail.lotID))}</Col>
                    </Row>
                  </td>
                  <td>
                    {getInvoiceDetailStatus(
                      get(detail, 'additionalPriceInfo.additionalChargeSentDateString', ''),
                      get(detail, 'additionalPriceInfo.paidDateString', ''),
                      get(detail, 'additionalPriceInfo.onlinePaymentStat', ''),
                      get(detail, 'additionalPriceInfo.paid', false)
                    )}
                    {get(detail, 'additionalPriceInfo.paid', false) && get(detail, 'additionalPriceInfo.paymentMethod', '').trim() === 'paidByWePay' && (
                      <span className=" ml-3">
                        <FontAwesomeIcon icon={faCreditCard} className="fa-lg" />
                      </span>
                    )}
                  </td>
                </tr>
              ))
              : null}
          </tbody>
        </Table>
      </UncontrolledCollapse>
    </>
  );
};
export default AdditionalChargesTable;
